import { createFileRoute } from '@tanstack/react-router'
import { AiSettingsView } from '@/features/settings/AiSettingsView'
import { AdminGuard } from '@/components/admin-guard'

export const Route = createFileRoute('/admin/settings')({
  component: () => (
    <AdminGuard>
      <AiSettingsView />
    </AdminGuard>
  ),
})
